var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable indent */
/* eslint-disable camelcase */
/* eslint-disable react/no-unsafe */
import classnames from 'classnames';
import throttle from 'lodash/throttle';
import omit from 'omit.js';
import React, { Component } from 'react';
import { STATS } from './constants';
import Footer from './footer';
import Header from './header';
class PullLoad extends Component {
    constructor(props) {
        super(props);
        this.$container = React.createRef();
        this.$parentContainer = null;
        this.$footer = React.createRef();
        this.convertScrollTop = (scrollTop) => {
            if (typeof scrollTop === 'number') {
                return {
                    value: scrollTop,
                    smooth: false
                };
            }
            else {
                return Object.assign({
                    smooth: false
                }, scrollTop);
            }
        };
        this.scrollTo = (scrollTop) => {
            const { block } = this.props;
            const { value, smooth } = scrollTop;
            setTimeout(() => {
                if (this.$parentContainer) {
                    (block ? this.$parentContainer : window).scrollTo({
                        top: value,
                        behavior: smooth ? 'smooth' : 'auto'
                    });
                }
            }, 0);
        };
        this.getScrollTop = () => {
            const { block } = this.props;
            if (block) {
                if (this.$parentContainer) {
                    return this.$parentContainer.scrollTop;
                }
                else {
                    return 0;
                }
            }
            else {
                return document.documentElement.scrollTop || document.body.scrollTop;
            }
        };
        this.canRefresh = () => {
            const { stat } = this.props;
            return [STATS.REFRESHING, STATS.LOADING].indexOf(stat) < 0;
        };
        this.onPullDownMove = (data) => {
            const { onAction, upperThreshold } = this.props;
            if (!this.canRefresh()) {
                return false;
            }
            let loaderState;
            const diff = (data.touchEndY - data.touchStartY) * 0.45;
            if (diff > upperThreshold) {
                loaderState = STATS.ENOUGH;
            }
            else {
                loaderState = STATS.PULLING;
            }
            this.setState({
                /** 限制下拉距离，最大默认为下拉刷新距离加50px */
                pullHeight: Math.min(diff, upperThreshold + 50)
            });
            onAction(loaderState);
        };
        this.onPullDownRefresh = () => {
            if (!this.canRefresh()) {
                return false;
            }
            const { stat, onAction } = this.props;
            if (stat === STATS.PULLING) {
                this.setState({ pullHeight: 0 });
                onAction(STATS.RESET);
            }
            else if (stat === STATS.ENOUGH) {
                this.setState({
                    pullHeight: 0
                });
                onAction(STATS.REFRESHING);
            }
        };
        this.onPullUpMove = () => {
            if (!this.canRefresh()) {
                return false;
            }
            const { onAction } = this.props;
            this.setState({
                pullHeight: 0
            });
            onAction(STATS.LOADING);
        };
        this.onTouchStart = (event) => {
            const targetEvent = event.changedTouches[0];
            this.startX = targetEvent.clientX;
            this.startY = targetEvent.clientY;
        };
        this.onTouchMove = (event) => {
            if (!this.$parentContainer) {
                return;
            }
            const { refreshEnable, offsetScrollTop } = this.props;
            const scrollTop = this.getScrollTop();
            const targetEvent = event.changedTouches[0];
            const curY = targetEvent.clientY;
            const diffY = curY - this.startY;
            // 判断垂直移动距离是否大于5
            if (Math.abs(diffY) > 5) {
                // 滚动距离小于设定值 &&回调onPullDownMove 函数，并且回传位置值
                if (diffY > 5 && scrollTop < offsetScrollTop) {
                    if (refreshEnable) {
                        // 阻止执行浏览器默认动作
                        event.preventDefault();
                        this.onPullDownMove({
                            touchStartY: this.startY,
                            touchEndY: curY
                        });
                    }
                }
            }
        };
        this.onTouchEnd = (event) => {
            if (!this.$parentContainer) {
                return;
            }
            const { offsetScrollTop, refreshEnable, block, lowerThreshold, loadEnable } = this.props;
            const scrollTop = this.getScrollTop();
            const scrollHeight = this.$parentContainer.scrollHeight;
            const containerHeight = block ? this.$parentContainer.offsetHeight : document.documentElement.clientHeight;
            const targetEvent = event.changedTouches[0];
            const curY = targetEvent.clientY;
            const diffY = curY - this.startY;
            // 判断垂直移动距离是否大于5
            if (Math.abs(diffY) > 5) {
                if (diffY > 5 && scrollTop < offsetScrollTop) {
                    // 回调onPullDownRefresh 函数，即满足刷新条件
                    if (refreshEnable) {
                        this.onPullDownRefresh();
                    }
                }
                else if (diffY < 0 && scrollHeight - scrollTop - containerHeight < lowerThreshold) {
                    // 滚动距离距离底部小于设定值
                    if (loadEnable) {
                        this.onPullUpMove();
                    }
                }
            }
        };
        this.onScroll = throttle((e) => {
            if (!this.$parentContainer) {
                return;
            }
            const { block, lowerThreshold, loadEnable, onScroll } = this.props;
            const scrollTop = this.getScrollTop();
            onScroll && onScroll(e, scrollTop);
            const scrollHeight = this.$parentContainer.scrollHeight;
            const containerHeight = block ? this.$parentContainer.offsetHeight : document.documentElement.clientHeight;
            if (scrollHeight - scrollTop - containerHeight < lowerThreshold) {
                // 滚动距离距离底部小于设定值
                if (loadEnable) {
                    this.onPullUpMove();
                }
            }
        }, 200);
        this.state = {
            pullHeight: 0
        };
    }
    componentDidMount() {
        const { block, scrollTop } = this.props;
        this.$parentContainer = block ? this.$container.current : document.body;
        /*
          As below reason handle touch event self ( widthout react defualt touch)
          Unable to preventDefault inside passive event listener due to target being treated as passive. See https://www.chromestatus.com/features/5093566007214080
        */
        if (this.$parentContainer && this.$container.current) {
            this.$container.current.addEventListener('touchstart', this.onTouchStart, { passive: false });
            this.$container.current.addEventListener('touchmove', this.onTouchMove, { passive: false });
            this.$container.current.addEventListener('touchend', this.onTouchEnd, { passive: false });
            this.$container.current.addEventListener('touchcancel', this.onTouchEnd, { passive: false });
            (block ? this.$parentContainer : window).addEventListener('scroll', this.onScroll);
        }
        if (scrollTop) {
            this.scrollTo(this.convertScrollTop(scrollTop));
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { onAction } = this.props;
        if (nextProps.stat === STATS.REFRESHED) {
            setTimeout(() => {
                onAction(STATS.RESET);
            }, 1000);
        }
    }
    componentDidUpdate(prevProps) {
        const { scrollTop } = this.props;
        if (scrollTop) {
            const prevScrollTop = prevProps.scrollTop ? this.convertScrollTop(prevProps.scrollTop) : undefined;
            const curScrollTop = this.convertScrollTop(scrollTop);
            if (!prevScrollTop || prevScrollTop.value !== curScrollTop.value) {
                this.scrollTo(curScrollTop);
            }
        }
    }
    componentWillUnmount() {
        const { block } = this.props;
        if (this.$parentContainer && this.$container.current) {
            this.$container.current.removeEventListener('touchstart', this.onTouchStart, false);
            this.$container.current.removeEventListener('touchmove', this.onTouchMove, false);
            this.$container.current.removeEventListener('touchend', this.onTouchEnd, false);
            this.$container.current.removeEventListener('touchcancel', this.onTouchEnd, false);
            (block ? this.$parentContainer : window).removeEventListener('scroll', this.onScroll);
        }
    }
    render() {
        const _a = this.props, { className, children, stat, block, header, footer, refreshEnable, loadEnable, hasMore } = _a, restProps = __rest(_a, ["className", "children", "stat", "block", "header", "footer", "refreshEnable", "loadEnable", "hasMore"]);
        const { pullHeight } = this.state;
        const msgStyle = (pullHeight
            ? {
                WebkitTransform: `translate3d(0, ${pullHeight}px, 0)`,
                transform: `translate3d(0, ${pullHeight}px, 0)`
            }
            : null);
        const boxClassName = classnames('pull-load', {
            'pull-load-block': block
        }, {
            [`pull-load-state-${stat}`]: stat
        }, className);
        return (React.createElement("div", Object.assign({ className: boxClassName, ref: this.$container }, omit(restProps, [
            'upperThreshold',
            'lowerThreshold',
            'onAction',
            'offsetScrollTop',
            'onScroll',
            'scrollTop'
        ])),
            React.createElement("div", { className: "pull-load-body", style: msgStyle },
                refreshEnable && (React.createElement("div", { className: "pull-load-header" }, React.isValidElement(header) &&
                    React.cloneElement(header, {
                        stat
                    }))),
                children,
                loadEnable && (React.createElement("div", { className: "pull-load-footer", ref: this.$footer }, React.isValidElement(footer) &&
                    React.cloneElement(footer, {
                        stat,
                        hasMore
                    }))))));
    }
}
PullLoad.defaultProps = {
    block: false,
    footer: React.createElement(Footer, null),
    hasMore: true,
    header: React.createElement(Header, null),
    lowerThreshold: 100,
    offsetScrollTop: 1,
    upperThreshold: 100
};
export default PullLoad;
